import type { FetchResponse } from "ofetch";
import type { PaginationData } from "@@/types/UsersRepository";

// Helpers to work with Pagy in the frontend
export const extractPagyHeaders = async (req) => {
  const response = await req;
  const page = parseInt(response.headers['current-page']);
  const totalCount = parseInt(response.headers['total-count']);
  const totalPages = parseInt(response.headers['total-pages']);
  return [response.data, { page, totalCount, totalPages }];
};

export const extractPagyHeadersFromFetch = async <T>(req:Promise<FetchResponse<T>>): Promise<[T, PaginationData]> => {
  const response = await req;
  const page = parseInt(response.headers.get('current-page'));
  const totalCount = parseInt(response.headers.get('total-count'));
  const totalPages = parseInt(response.headers.get('total-pages'));
  return [response._data as T, { page, totalCount, totalPages }];
};
